export default "__VITE_ASSET__NgFmqjfa__"